/**
 * This function checks if any of the provided arguments are not null or undefined.
 * @param args
 * @returns
 */
export function hasNonNull(...args: unknown[]): boolean {
	if (!args) {
		return false;
	}
	if (args.length === 0) return false;
	return args.some((arg) => arg !== null && arg !== undefined);
}
